import React from "react";
import { useTranslation } from "react-i18next";
import Millimetre from "../../../../components/Math/Units/Metric/Millimetre";
import { RowBody } from "../../../../components/RowValue/RowBody";

function Einbindelaenge_in_Baugrund({ einbindelaenge_in_baugrund = 0 }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("aeussre.embedmentLengthBuildingGround")}</p>}
      indicesValue={
        <span>
          L<sub>b min</sub>
        </span>
      }
      inputValue={<span className="input">{einbindelaenge_in_baugrund}</span>}
      unitValue={<Millimetre />}
    />
  );
}

export default Einbindelaenge_in_Baugrund;
